import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #C8C8C8;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 48px;
  position: relative;
  cursor: pointer;

  & + & {
    margin-top: 24px;
  }

  table {
    width: 100%;
    border-spacing: 0;
    table-layout: fixed;

    th {
      font-weight: 900;
      font-size: 14px;
      line-height: 19px;
      color: #7B7C82;
      text-align: left;
      border-bottom: 1px solid #EFEFEF;
      padding: 8px 0;
    }

    td {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #1F202C;
      padding: 8px 0;
    }

    td:first-of-type {
      font-weight: 900;
      line-height: 21px;
      color: #353744;
    }
  }
`

export const HoveredContainer = styled.div`
  width: 56%;
  min-width: 600px;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0.23042720506171221) 0%, rgba(255,255,255,1) 37%);
  display: none;
  padding-right: 48px;

  &.hovered {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 48px;
  }
`